import { Icon, IconEnum as IconEnum } from '@investoro/core';

export { IconEnum };
export default Icon;
